// src/utils/utils_broadcastingDurationPurchase.ts
// Point d'entrée unique de l'action « Acheter de la durée de diffusion ».
//
// La mécanique (choix du palier si plusieurs sont actifs, ajout au panier, ouverture
// directe du paiement) est partagée entre les 5 ressources CreatorCapacity — voir
// utils_creatorCapacityPurchase.ts. Un des paliers ("Illimité") fixe la durée sur
// Admin::DUREE_SANS_LIMITE au lieu de l'additionner — traité côté
// SaleActionProcessor_Lovelight_TV_Buying_creator_capacity, transparent ici. Seule cette
// fonction est à modifier si le point d'entrée change — tous les appelants suivront.

import { buyCreatorCapacity }  from "./utils_creatorCapacityPurchase";

export const BUY_BROADCASTING_DURATION_LABEL = 'Acheter de la durée de diffusion';

/**
 * @param notify  Fonction d'affichage du message. Par défaut window.alert ;
 *                les écrans disposant d'une fenêtre applicative (régie…) passent la leur.
 */
export async function openBuyBroadcastingDuration(
  notify: (message: string) => void = (message) => window.alert(message)
): Promise<void> {
  return buyCreatorCapacity(
    'broadcasting',
    "L'achat de durée de diffusion supplémentaire n'est pas encore disponible.",
    '+ de durée de diffusion',
    notify
  );
}
